// source: services/voip/voip.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var services_account_account_pb = require('../../services/account/account_pb.js');
goog.object.extend(proto, services_account_account_pb);
var services_common_common_pb = require('../../services/common/common_pb.js');
goog.object.extend(proto, services_common_common_pb);
goog.exportSymbol('proto.social.voip.AccountEssentialsFields', null, global);
goog.exportSymbol('proto.social.voip.AdminFAQ', null, global);
goog.exportSymbol('proto.social.voip.AdminFAQListResponse', null, global);
goog.exportSymbol('proto.social.voip.AdminGetSupportReport', null, global);
goog.exportSymbol('proto.social.voip.AdminGetSupportReportItem', null, global);
goog.exportSymbol('proto.social.voip.AdminGetSupportReportRequest', null, global);
goog.exportSymbol('proto.social.voip.AdminGetSupportReportResponse', null, global);
goog.exportSymbol('proto.social.voip.AdminVoipOperatorDailyStats', null, global);
goog.exportSymbol('proto.social.voip.AdminVoipOperatorReportRequest', null, global);
goog.exportSymbol('proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType', null, global);
goog.exportSymbol('proto.social.voip.AdminVoipOperatorReportResponse', null, global);
goog.exportSymbol('proto.social.voip.ConnectionType', null, global);
goog.exportSymbol('proto.social.voip.FAQ', null, global);
goog.exportSymbol('proto.social.voip.FAQListResponse', null, global);
goog.exportSymbol('proto.social.voip.FinishSupportRequest', null, global);
goog.exportSymbol('proto.social.voip.QueueConnectionType', null, global);
goog.exportSymbol('proto.social.voip.QueueData', null, global);
goog.exportSymbol('proto.social.voip.QuickAccess', null, global);
goog.exportSymbol('proto.social.voip.QuickAccessListResponse', null, global);
goog.exportSymbol('proto.social.voip.QuickAnswer', null, global);
goog.exportSymbol('proto.social.voip.QuickAnswerListResponse', null, global);
goog.exportSymbol('proto.social.voip.Satisfaction', null, global);
goog.exportSymbol('proto.social.voip.SubmitFeedbackRequest', null, global);
goog.exportSymbol('proto.social.voip.SubmitFeedbackRequest.Satisfaction', null, global);
goog.exportSymbol('proto.social.voip.SupportQueueRequest', null, global);
goog.exportSymbol('proto.social.voip.SupportQueueResponse', null, global);
goog.exportSymbol('proto.social.voip.SupportStatus', null, global);
goog.exportSymbol('proto.social.voip.UserInQueue', null, global);
goog.exportSymbol('proto.social.voip.VoipCallRequest', null, global);
goog.exportSymbol('proto.social.voip.VoipLog', null, global);
goog.exportSymbol('proto.social.voip.VoipLogRequest', null, global);
goog.exportSymbol('proto.social.voip.VoipLogResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.SupportQueueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.SupportQueueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.SupportQueueRequest.displayName = 'proto.social.voip.SupportQueueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.UserInQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.UserInQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.UserInQueue.displayName = 'proto.social.voip.UserInQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.SupportQueueResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.SupportQueueResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.SupportQueueResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.SupportQueueResponse.displayName = 'proto.social.voip.SupportQueueResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.QueueData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.QueueData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.QueueData.displayName = 'proto.social.voip.QueueData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminVoipOperatorReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AdminVoipOperatorReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminVoipOperatorReportRequest.displayName = 'proto.social.voip.AdminVoipOperatorReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminVoipOperatorDailyStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AdminVoipOperatorDailyStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminVoipOperatorDailyStats.displayName = 'proto.social.voip.AdminVoipOperatorDailyStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminVoipOperatorReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.AdminVoipOperatorReportResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.AdminVoipOperatorReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminVoipOperatorReportResponse.displayName = 'proto.social.voip.AdminVoipOperatorReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.FinishSupportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.FinishSupportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.FinishSupportRequest.displayName = 'proto.social.voip.FinishSupportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.SubmitFeedbackRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.SubmitFeedbackRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.SubmitFeedbackRequest.displayName = 'proto.social.voip.SubmitFeedbackRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.FAQ = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.FAQ.repeatedFields_, null);
};
goog.inherits(proto.social.voip.FAQ, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.FAQ.displayName = 'proto.social.voip.FAQ';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.FAQListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.FAQListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.FAQListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.FAQListResponse.displayName = 'proto.social.voip.FAQListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.QuickAccess = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.QuickAccess, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.QuickAccess.displayName = 'proto.social.voip.QuickAccess';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.QuickAccessListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.QuickAccessListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.QuickAccessListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.QuickAccessListResponse.displayName = 'proto.social.voip.QuickAccessListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminFAQ = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.AdminFAQ.repeatedFields_, null);
};
goog.inherits(proto.social.voip.AdminFAQ, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminFAQ.displayName = 'proto.social.voip.AdminFAQ';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminFAQListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.AdminFAQListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.AdminFAQListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminFAQListResponse.displayName = 'proto.social.voip.AdminFAQListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.Satisfaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.Satisfaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.Satisfaction.displayName = 'proto.social.voip.Satisfaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.ConnectionType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.ConnectionType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.ConnectionType.displayName = 'proto.social.voip.ConnectionType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminGetSupportReportItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AdminGetSupportReportItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminGetSupportReportItem.displayName = 'proto.social.voip.AdminGetSupportReportItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminGetSupportReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AdminGetSupportReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminGetSupportReportRequest.displayName = 'proto.social.voip.AdminGetSupportReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AccountEssentialsFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AccountEssentialsFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AccountEssentialsFields.displayName = 'proto.social.voip.AccountEssentialsFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminGetSupportReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.AdminGetSupportReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminGetSupportReport.displayName = 'proto.social.voip.AdminGetSupportReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.AdminGetSupportReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.AdminGetSupportReportResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.AdminGetSupportReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.AdminGetSupportReportResponse.displayName = 'proto.social.voip.AdminGetSupportReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.VoipLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.VoipLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.VoipLogRequest.displayName = 'proto.social.voip.VoipLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.VoipLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.VoipLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.VoipLog.displayName = 'proto.social.voip.VoipLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.VoipLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.VoipLogResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.VoipLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.VoipLogResponse.displayName = 'proto.social.voip.VoipLogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.QuickAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.QuickAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.QuickAnswer.displayName = 'proto.social.voip.QuickAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.QuickAnswerListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.voip.QuickAnswerListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.voip.QuickAnswerListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.QuickAnswerListResponse.displayName = 'proto.social.voip.QuickAnswerListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.voip.VoipCallRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.voip.VoipCallRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.voip.VoipCallRequest.displayName = 'proto.social.voip.VoipCallRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.SupportQueueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.SupportQueueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.SupportQueueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SupportQueueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.SupportQueueRequest}
 */
proto.social.voip.SupportQueueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.SupportQueueRequest;
  return proto.social.voip.SupportQueueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.SupportQueueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.SupportQueueRequest}
 */
proto.social.voip.SupportQueueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.social.voip.SupportStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.SupportQueueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.SupportQueueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.SupportQueueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SupportQueueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional SupportStatus status = 1;
 * @return {!proto.social.voip.SupportStatus}
 */
proto.social.voip.SupportQueueRequest.prototype.getStatus = function() {
  return /** @type {!proto.social.voip.SupportStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.social.voip.SupportStatus} value
 * @return {!proto.social.voip.SupportQueueRequest} returns this
 */
proto.social.voip.SupportQueueRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.UserInQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.UserInQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.UserInQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.UserInQueue.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && services_account_account_pb.Account.toObject(includeInstance, f),
    waitingTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    position: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    voipLogId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.UserInQueue}
 */
proto.social.voip.UserInQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.UserInQueue;
  return proto.social.voip.UserInQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.UserInQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.UserInQueue}
 */
proto.social.voip.UserInQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new services_account_account_pb.Account;
      reader.readMessage(value,services_account_account_pb.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWaitingTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoipLogId(value);
      break;
    case 7:
      var value = /** @type {!proto.social.voip.QueueConnectionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.UserInQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.UserInQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.UserInQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.UserInQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      services_account_account_pb.Account.serializeBinaryToWriter
    );
  }
  f = message.getWaitingTime();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getVoipLogId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional social.account.Account account = 2;
 * @return {?proto.social.account.Account}
 */
proto.social.voip.UserInQueue.prototype.getAccount = function() {
  return /** @type{?proto.social.account.Account} */ (
    jspb.Message.getWrapperField(this, services_account_account_pb.Account, 2));
};


/**
 * @param {?proto.social.account.Account|undefined} value
 * @return {!proto.social.voip.UserInQueue} returns this
*/
proto.social.voip.UserInQueue.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.UserInQueue.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 waiting_time = 3;
 * @return {number}
 */
proto.social.voip.UserInQueue.prototype.getWaitingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.setWaitingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 position = 4;
 * @return {number}
 */
proto.social.voip.UserInQueue.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 status = 5;
 * @return {number}
 */
proto.social.voip.UserInQueue.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string voip_log_id = 6;
 * @return {string}
 */
proto.social.voip.UserInQueue.prototype.getVoipLogId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.setVoipLogId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional QueueConnectionType type = 7;
 * @return {!proto.social.voip.QueueConnectionType}
 */
proto.social.voip.UserInQueue.prototype.getType = function() {
  return /** @type {!proto.social.voip.QueueConnectionType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.social.voip.QueueConnectionType} value
 * @return {!proto.social.voip.UserInQueue} returns this
 */
proto.social.voip.UserInQueue.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.SupportQueueResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.SupportQueueResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.SupportQueueResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.SupportQueueResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SupportQueueResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    onlineOperators: jspb.Message.getFieldWithDefault(msg, 1, 0),
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.social.voip.UserInQueue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.SupportQueueResponse}
 */
proto.social.voip.SupportQueueResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.SupportQueueResponse;
  return proto.social.voip.SupportQueueResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.SupportQueueResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.SupportQueueResponse}
 */
proto.social.voip.SupportQueueResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOnlineOperators(value);
      break;
    case 2:
      var value = new proto.social.voip.UserInQueue;
      reader.readMessage(value,proto.social.voip.UserInQueue.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.SupportQueueResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.SupportQueueResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.SupportQueueResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SupportQueueResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnlineOperators();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.social.voip.UserInQueue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 online_operators = 1;
 * @return {number}
 */
proto.social.voip.SupportQueueResponse.prototype.getOnlineOperators = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.SupportQueueResponse} returns this
 */
proto.social.voip.SupportQueueResponse.prototype.setOnlineOperators = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated UserInQueue users = 2;
 * @return {!Array<!proto.social.voip.UserInQueue>}
 */
proto.social.voip.SupportQueueResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.social.voip.UserInQueue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.UserInQueue, 2));
};


/**
 * @param {!Array<!proto.social.voip.UserInQueue>} value
 * @return {!proto.social.voip.SupportQueueResponse} returns this
*/
proto.social.voip.SupportQueueResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.social.voip.UserInQueue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.UserInQueue}
 */
proto.social.voip.SupportQueueResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.social.voip.UserInQueue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.SupportQueueResponse} returns this
 */
proto.social.voip.SupportQueueResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.QueueData.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.QueueData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.QueueData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QueueData.toObject = function(includeInstance, msg) {
  var f, obj = {
    internalId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    joinUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    roomId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    roomName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.QueueData}
 */
proto.social.voip.QueueData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.QueueData;
  return proto.social.voip.QueueData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.QueueData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.QueueData}
 */
proto.social.voip.QueueData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoinUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomName(value);
      break;
    case 5:
      var value = /** @type {!proto.social.voip.QueueConnectionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.QueueData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.QueueData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.QueueData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QueueData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInternalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJoinUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRoomName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string internal_id = 1;
 * @return {string}
 */
proto.social.voip.QueueData.prototype.getInternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setInternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string external_id = 2;
 * @return {string}
 */
proto.social.voip.QueueData.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string join_url = 3;
 * @return {string}
 */
proto.social.voip.QueueData.prototype.getJoinUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setJoinUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string room_id = 4;
 * @return {string}
 */
proto.social.voip.QueueData.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string room_name = 6;
 * @return {string}
 */
proto.social.voip.QueueData.prototype.getRoomName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setRoomName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional QueueConnectionType type = 5;
 * @return {!proto.social.voip.QueueConnectionType}
 */
proto.social.voip.QueueData.prototype.getType = function() {
  return /** @type {!proto.social.voip.QueueConnectionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.social.voip.QueueConnectionType} value
 * @return {!proto.social.voip.QueueData} returns this
 */
proto.social.voip.QueueData.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminVoipOperatorReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hasAnswered: jspb.Message.getFieldWithDefault(msg, 2, ""),
    operator: (f = msg.getOperator()) && services_account_account_pb.Account.toObject(includeInstance, f),
    start: jspb.Message.getFieldWithDefault(msg, 4, ""),
    end: jspb.Message.getFieldWithDefault(msg, 5, ""),
    download: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest}
 */
proto.social.voip.AdminVoipOperatorReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminVoipOperatorReportRequest;
  return proto.social.voip.AdminVoipOperatorReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest}
 */
proto.social.voip.AdminVoipOperatorReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHasAnswered(value);
      break;
    case 3:
      var value = new services_account_account_pb.Account;
      reader.readMessage(value,services_account_account_pb.Account.deserializeBinaryFromReader);
      msg.setOperator(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDownload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminVoipOperatorReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHasAnswered();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperator();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      services_account_account_pb.Account.serializeBinaryToWriter
    );
  }
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDownload();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType = {
  MEETING: 0,
  CHAT: 1,
  ALL: 2
};

/**
 * optional ConnectionType type = 1;
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getType = function() {
  return /** @type {!proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest.ConnectionType} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string has_answered = 2;
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getHasAnswered = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setHasAnswered = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional social.account.Account operator = 3;
 * @return {?proto.social.account.Account}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getOperator = function() {
  return /** @type{?proto.social.account.Account} */ (
    jspb.Message.getWrapperField(this, services_account_account_pb.Account, 3));
};


/**
 * @param {?proto.social.account.Account|undefined} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
*/
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setOperator = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.clearOperator = function() {
  return this.setOperator(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.hasOperator = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string start = 4;
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string end = 5;
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool download = 6;
 * @return {boolean}
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.getDownload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.voip.AdminVoipOperatorReportRequest} returns this
 */
proto.social.voip.AdminVoipOperatorReportRequest.prototype.setDownload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminVoipOperatorDailyStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminVoipOperatorDailyStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorDailyStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalMeetTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    meanWaitingTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalItems: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats}
 */
proto.social.voip.AdminVoipOperatorDailyStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminVoipOperatorDailyStats;
  return proto.social.voip.AdminVoipOperatorDailyStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminVoipOperatorDailyStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats}
 */
proto.social.voip.AdminVoipOperatorDailyStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalMeetTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMeanWaitingTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminVoipOperatorDailyStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminVoipOperatorDailyStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorDailyStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalMeetTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMeanWaitingTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats} returns this
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 total_meet_time = 2;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.getTotalMeetTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats} returns this
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.setTotalMeetTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 mean_waiting_time = 3;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.getMeanWaitingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats} returns this
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.setMeanWaitingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_items = 4;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats} returns this
 */
proto.social.voip.AdminVoipOperatorDailyStats.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.AdminVoipOperatorReportResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminVoipOperatorReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminVoipOperatorReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dailyStatsList: jspb.Message.toObjectList(msg.getDailyStatsList(),
    proto.social.voip.AdminVoipOperatorDailyStats.toObject, includeInstance),
    totalMeetTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    overallMeanWaitingTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalItems: jspb.Message.getFieldWithDefault(msg, 4, 0),
    fileContent: msg.getFileContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse}
 */
proto.social.voip.AdminVoipOperatorReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminVoipOperatorReportResponse;
  return proto.social.voip.AdminVoipOperatorReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminVoipOperatorReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse}
 */
proto.social.voip.AdminVoipOperatorReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.AdminVoipOperatorDailyStats;
      reader.readMessage(value,proto.social.voip.AdminVoipOperatorDailyStats.deserializeBinaryFromReader);
      msg.addDailyStats(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalMeetTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverallMeanWaitingTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminVoipOperatorReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminVoipOperatorReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminVoipOperatorReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.AdminVoipOperatorDailyStats.serializeBinaryToWriter
    );
  }
  f = message.getTotalMeetTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOverallMeanWaitingTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
};


/**
 * repeated AdminVoipOperatorDailyStats daily_stats = 1;
 * @return {!Array<!proto.social.voip.AdminVoipOperatorDailyStats>}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getDailyStatsList = function() {
  return /** @type{!Array<!proto.social.voip.AdminVoipOperatorDailyStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.AdminVoipOperatorDailyStats, 1));
};


/**
 * @param {!Array<!proto.social.voip.AdminVoipOperatorDailyStats>} value
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
*/
proto.social.voip.AdminVoipOperatorReportResponse.prototype.setDailyStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.AdminVoipOperatorDailyStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.AdminVoipOperatorDailyStats}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.addDailyStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.AdminVoipOperatorDailyStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.clearDailyStatsList = function() {
  return this.setDailyStatsList([]);
};


/**
 * optional int64 total_meet_time = 2;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getTotalMeetTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.setTotalMeetTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 overall_mean_waiting_time = 3;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getOverallMeanWaitingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.setOverallMeanWaitingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_items = 4;
 * @return {number}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bytes file_content = 5;
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes file_content = 5;
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {string}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileContent()));
};


/**
 * optional bytes file_content = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {!Uint8Array}
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.getFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.social.voip.AdminVoipOperatorReportResponse} returns this
 */
proto.social.voip.AdminVoipOperatorReportResponse.prototype.setFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.FinishSupportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.FinishSupportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.FinishSupportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FinishSupportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.FinishSupportRequest}
 */
proto.social.voip.FinishSupportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.FinishSupportRequest;
  return proto.social.voip.FinishSupportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.FinishSupportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.FinishSupportRequest}
 */
proto.social.voip.FinishSupportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.FinishSupportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.FinishSupportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.FinishSupportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FinishSupportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string room_id = 1;
 * @return {string}
 */
proto.social.voip.FinishSupportRequest.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.FinishSupportRequest} returns this
 */
proto.social.voip.FinishSupportRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.SubmitFeedbackRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.SubmitFeedbackRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.SubmitFeedbackRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SubmitFeedbackRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    score: jspb.Message.getFieldWithDefault(msg, 2, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.SubmitFeedbackRequest}
 */
proto.social.voip.SubmitFeedbackRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.SubmitFeedbackRequest;
  return proto.social.voip.SubmitFeedbackRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.SubmitFeedbackRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.SubmitFeedbackRequest}
 */
proto.social.voip.SubmitFeedbackRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 2:
      var value = /** @type {!proto.social.voip.SubmitFeedbackRequest.Satisfaction} */ (reader.readEnum());
      msg.setScore(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.SubmitFeedbackRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.SubmitFeedbackRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.SubmitFeedbackRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.SubmitFeedbackRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.social.voip.SubmitFeedbackRequest.Satisfaction = {
  TERRIBLE: 0,
  BAD: 1,
  GOOD: 2,
  EXCELLENT: 3
};

/**
 * optional string room_id = 1;
 * @return {string}
 */
proto.social.voip.SubmitFeedbackRequest.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.SubmitFeedbackRequest} returns this
 */
proto.social.voip.SubmitFeedbackRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Satisfaction score = 2;
 * @return {!proto.social.voip.SubmitFeedbackRequest.Satisfaction}
 */
proto.social.voip.SubmitFeedbackRequest.prototype.getScore = function() {
  return /** @type {!proto.social.voip.SubmitFeedbackRequest.Satisfaction} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.social.voip.SubmitFeedbackRequest.Satisfaction} value
 * @return {!proto.social.voip.SubmitFeedbackRequest} returns this
 */
proto.social.voip.SubmitFeedbackRequest.prototype.setScore = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string comment = 3;
 * @return {string}
 */
proto.social.voip.SubmitFeedbackRequest.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.SubmitFeedbackRequest} returns this
 */
proto.social.voip.SubmitFeedbackRequest.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.FAQ.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.FAQ.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.FAQ.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.FAQ} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FAQ.toObject = function(includeInstance, msg) {
  var f, obj = {
    isQuestion: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    childrenList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    id: jspb.Message.getFieldWithDefault(msg, 5, ""),
    networkId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.FAQ}
 */
proto.social.voip.FAQ.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.FAQ;
  return proto.social.voip.FAQ.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.FAQ} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.FAQ}
 */
proto.social.voip.FAQ.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsQuestion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addChildren(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.FAQ.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.FAQ.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.FAQ} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FAQ.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsQuestion();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional bool is_question = 1;
 * @return {boolean}
 */
proto.social.voip.FAQ.prototype.getIsQuestion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setIsQuestion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.social.voip.FAQ.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parent = 3;
 * @return {string}
 */
proto.social.voip.FAQ.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string children = 4;
 * @return {!Array<string>}
 */
proto.social.voip.FAQ.prototype.getChildrenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setChildrenList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.addChildren = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};


/**
 * optional string id = 5;
 * @return {string}
 */
proto.social.voip.FAQ.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string network_id = 6;
 * @return {string}
 */
proto.social.voip.FAQ.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.FAQ} returns this
 */
proto.social.voip.FAQ.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.FAQListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.FAQListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.FAQListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.FAQListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FAQListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.FAQ.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.FAQListResponse}
 */
proto.social.voip.FAQListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.FAQListResponse;
  return proto.social.voip.FAQListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.FAQListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.FAQListResponse}
 */
proto.social.voip.FAQListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.FAQ;
      reader.readMessage(value,proto.social.voip.FAQ.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.FAQListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.FAQListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.FAQListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.FAQListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.FAQ.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated FAQ items = 1;
 * @return {!Array<!proto.social.voip.FAQ>}
 */
proto.social.voip.FAQListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.FAQ>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.FAQ, 1));
};


/**
 * @param {!Array<!proto.social.voip.FAQ>} value
 * @return {!proto.social.voip.FAQListResponse} returns this
*/
proto.social.voip.FAQListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.FAQ=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.FAQ}
 */
proto.social.voip.FAQListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.FAQ, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.FAQListResponse} returns this
 */
proto.social.voip.FAQListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.voip.FAQListResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.FAQListResponse} returns this
 */
proto.social.voip.FAQListResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.QuickAccess.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.QuickAccess.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.QuickAccess} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAccess.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    body: jspb.Message.getFieldWithDefault(msg, 3, ""),
    networkId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.QuickAccess}
 */
proto.social.voip.QuickAccess.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.QuickAccess;
  return proto.social.voip.QuickAccess.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.QuickAccess} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.QuickAccess}
 */
proto.social.voip.QuickAccess.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.QuickAccess.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.QuickAccess.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.QuickAccess} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAccess.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.social.voip.QuickAccess.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAccess} returns this
 */
proto.social.voip.QuickAccess.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.social.voip.QuickAccess.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAccess} returns this
 */
proto.social.voip.QuickAccess.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.social.voip.QuickAccess.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAccess} returns this
 */
proto.social.voip.QuickAccess.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string network_id = 4;
 * @return {string}
 */
proto.social.voip.QuickAccess.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAccess} returns this
 */
proto.social.voip.QuickAccess.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.QuickAccessListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.QuickAccessListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.QuickAccessListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.QuickAccessListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAccessListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.QuickAccess.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.QuickAccessListResponse}
 */
proto.social.voip.QuickAccessListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.QuickAccessListResponse;
  return proto.social.voip.QuickAccessListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.QuickAccessListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.QuickAccessListResponse}
 */
proto.social.voip.QuickAccessListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.QuickAccess;
      reader.readMessage(value,proto.social.voip.QuickAccess.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.QuickAccessListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.QuickAccessListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.QuickAccessListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAccessListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.QuickAccess.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated QuickAccess items = 1;
 * @return {!Array<!proto.social.voip.QuickAccess>}
 */
proto.social.voip.QuickAccessListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.QuickAccess>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.QuickAccess, 1));
};


/**
 * @param {!Array<!proto.social.voip.QuickAccess>} value
 * @return {!proto.social.voip.QuickAccessListResponse} returns this
*/
proto.social.voip.QuickAccessListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.QuickAccess=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.QuickAccess}
 */
proto.social.voip.QuickAccessListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.QuickAccess, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.QuickAccessListResponse} returns this
 */
proto.social.voip.QuickAccessListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.voip.QuickAccessListResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.QuickAccessListResponse} returns this
 */
proto.social.voip.QuickAccessListResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.AdminFAQ.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminFAQ.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminFAQ.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminFAQ} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminFAQ.toObject = function(includeInstance, msg) {
  var f, obj = {
    isQuestion: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.social.voip.AdminFAQ.toObject, includeInstance),
    id: jspb.Message.getFieldWithDefault(msg, 5, ""),
    networkId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminFAQ}
 */
proto.social.voip.AdminFAQ.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminFAQ;
  return proto.social.voip.AdminFAQ.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminFAQ} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminFAQ}
 */
proto.social.voip.AdminFAQ.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsQuestion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 4:
      var value = new proto.social.voip.AdminFAQ;
      reader.readMessage(value,proto.social.voip.AdminFAQ.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminFAQ.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminFAQ.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminFAQ} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminFAQ.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsQuestion();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.social.voip.AdminFAQ.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional bool is_question = 1;
 * @return {boolean}
 */
proto.social.voip.AdminFAQ.prototype.getIsQuestion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.setIsQuestion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.social.voip.AdminFAQ.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parent = 3;
 * @return {string}
 */
proto.social.voip.AdminFAQ.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated AdminFAQ children = 4;
 * @return {!Array<!proto.social.voip.AdminFAQ>}
 */
proto.social.voip.AdminFAQ.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.social.voip.AdminFAQ>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.AdminFAQ, 4));
};


/**
 * @param {!Array<!proto.social.voip.AdminFAQ>} value
 * @return {!proto.social.voip.AdminFAQ} returns this
*/
proto.social.voip.AdminFAQ.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.social.voip.AdminFAQ=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.AdminFAQ}
 */
proto.social.voip.AdminFAQ.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.social.voip.AdminFAQ, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};


/**
 * optional string id = 5;
 * @return {string}
 */
proto.social.voip.AdminFAQ.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string network_id = 6;
 * @return {string}
 */
proto.social.voip.AdminFAQ.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminFAQ} returns this
 */
proto.social.voip.AdminFAQ.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.AdminFAQListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminFAQListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminFAQListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminFAQListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminFAQListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.AdminFAQ.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminFAQListResponse}
 */
proto.social.voip.AdminFAQListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminFAQListResponse;
  return proto.social.voip.AdminFAQListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminFAQListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminFAQListResponse}
 */
proto.social.voip.AdminFAQListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.AdminFAQ;
      reader.readMessage(value,proto.social.voip.AdminFAQ.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminFAQListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminFAQListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminFAQListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminFAQListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.AdminFAQ.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated AdminFAQ items = 1;
 * @return {!Array<!proto.social.voip.AdminFAQ>}
 */
proto.social.voip.AdminFAQListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.AdminFAQ>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.AdminFAQ, 1));
};


/**
 * @param {!Array<!proto.social.voip.AdminFAQ>} value
 * @return {!proto.social.voip.AdminFAQListResponse} returns this
*/
proto.social.voip.AdminFAQListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.AdminFAQ=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.AdminFAQ}
 */
proto.social.voip.AdminFAQListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.AdminFAQ, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.AdminFAQListResponse} returns this
 */
proto.social.voip.AdminFAQListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.voip.AdminFAQListResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminFAQListResponse} returns this
 */
proto.social.voip.AdminFAQListResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.Satisfaction.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.Satisfaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.Satisfaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.Satisfaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    terrible: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bad: jspb.Message.getFieldWithDefault(msg, 2, 0),
    good: jspb.Message.getFieldWithDefault(msg, 3, 0),
    excellent: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.Satisfaction}
 */
proto.social.voip.Satisfaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.Satisfaction;
  return proto.social.voip.Satisfaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.Satisfaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.Satisfaction}
 */
proto.social.voip.Satisfaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTerrible(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBad(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGood(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExcellent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.Satisfaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.Satisfaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.Satisfaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.Satisfaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTerrible();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBad();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getGood();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getExcellent();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 terrible = 1;
 * @return {number}
 */
proto.social.voip.Satisfaction.prototype.getTerrible = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.Satisfaction} returns this
 */
proto.social.voip.Satisfaction.prototype.setTerrible = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 bad = 2;
 * @return {number}
 */
proto.social.voip.Satisfaction.prototype.getBad = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.Satisfaction} returns this
 */
proto.social.voip.Satisfaction.prototype.setBad = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 good = 3;
 * @return {number}
 */
proto.social.voip.Satisfaction.prototype.getGood = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.Satisfaction} returns this
 */
proto.social.voip.Satisfaction.prototype.setGood = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 excellent = 4;
 * @return {number}
 */
proto.social.voip.Satisfaction.prototype.getExcellent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.Satisfaction} returns this
 */
proto.social.voip.Satisfaction.prototype.setExcellent = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.ConnectionType.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.ConnectionType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.ConnectionType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.ConnectionType.toObject = function(includeInstance, msg) {
  var f, obj = {
    meeting: jspb.Message.getFieldWithDefault(msg, 1, 0),
    chat: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.ConnectionType}
 */
proto.social.voip.ConnectionType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.ConnectionType;
  return proto.social.voip.ConnectionType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.ConnectionType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.ConnectionType}
 */
proto.social.voip.ConnectionType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMeeting(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.ConnectionType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.ConnectionType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.ConnectionType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.ConnectionType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMeeting();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getChat();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 meeting = 1;
 * @return {number}
 */
proto.social.voip.ConnectionType.prototype.getMeeting = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.ConnectionType} returns this
 */
proto.social.voip.ConnectionType.prototype.setMeeting = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 chat = 2;
 * @return {number}
 */
proto.social.voip.ConnectionType.prototype.getChat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.ConnectionType} returns this
 */
proto.social.voip.ConnectionType.prototype.setChat = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminGetSupportReportItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminGetSupportReportItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    workingTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    satisfaction: (f = msg.getSatisfaction()) && proto.social.voip.Satisfaction.toObject(includeInstance, f),
    totalAnsweredCounts: (f = msg.getTotalAnsweredCounts()) && proto.social.voip.ConnectionType.toObject(includeInstance, f),
    totalAnsweredTime: (f = msg.getTotalAnsweredTime()) && proto.social.voip.ConnectionType.toObject(includeInstance, f),
    meanWaitingTime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminGetSupportReportItem}
 */
proto.social.voip.AdminGetSupportReportItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminGetSupportReportItem;
  return proto.social.voip.AdminGetSupportReportItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminGetSupportReportItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminGetSupportReportItem}
 */
proto.social.voip.AdminGetSupportReportItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkingTime(value);
      break;
    case 2:
      var value = new proto.social.voip.Satisfaction;
      reader.readMessage(value,proto.social.voip.Satisfaction.deserializeBinaryFromReader);
      msg.setSatisfaction(value);
      break;
    case 3:
      var value = new proto.social.voip.ConnectionType;
      reader.readMessage(value,proto.social.voip.ConnectionType.deserializeBinaryFromReader);
      msg.setTotalAnsweredCounts(value);
      break;
    case 4:
      var value = new proto.social.voip.ConnectionType;
      reader.readMessage(value,proto.social.voip.ConnectionType.deserializeBinaryFromReader);
      msg.setTotalAnsweredTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMeanWaitingTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminGetSupportReportItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminGetSupportReportItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkingTime();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSatisfaction();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.social.voip.Satisfaction.serializeBinaryToWriter
    );
  }
  f = message.getTotalAnsweredCounts();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.social.voip.ConnectionType.serializeBinaryToWriter
    );
  }
  f = message.getTotalAnsweredTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.social.voip.ConnectionType.serializeBinaryToWriter
    );
  }
  f = message.getMeanWaitingTime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 working_time = 1;
 * @return {number}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.getWorkingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
 */
proto.social.voip.AdminGetSupportReportItem.prototype.setWorkingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Satisfaction satisfaction = 2;
 * @return {?proto.social.voip.Satisfaction}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.getSatisfaction = function() {
  return /** @type{?proto.social.voip.Satisfaction} */ (
    jspb.Message.getWrapperField(this, proto.social.voip.Satisfaction, 2));
};


/**
 * @param {?proto.social.voip.Satisfaction|undefined} value
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
*/
proto.social.voip.AdminGetSupportReportItem.prototype.setSatisfaction = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
 */
proto.social.voip.AdminGetSupportReportItem.prototype.clearSatisfaction = function() {
  return this.setSatisfaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.hasSatisfaction = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ConnectionType total_answered_counts = 3;
 * @return {?proto.social.voip.ConnectionType}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.getTotalAnsweredCounts = function() {
  return /** @type{?proto.social.voip.ConnectionType} */ (
    jspb.Message.getWrapperField(this, proto.social.voip.ConnectionType, 3));
};


/**
 * @param {?proto.social.voip.ConnectionType|undefined} value
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
*/
proto.social.voip.AdminGetSupportReportItem.prototype.setTotalAnsweredCounts = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
 */
proto.social.voip.AdminGetSupportReportItem.prototype.clearTotalAnsweredCounts = function() {
  return this.setTotalAnsweredCounts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.hasTotalAnsweredCounts = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ConnectionType total_answered_time = 4;
 * @return {?proto.social.voip.ConnectionType}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.getTotalAnsweredTime = function() {
  return /** @type{?proto.social.voip.ConnectionType} */ (
    jspb.Message.getWrapperField(this, proto.social.voip.ConnectionType, 4));
};


/**
 * @param {?proto.social.voip.ConnectionType|undefined} value
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
*/
proto.social.voip.AdminGetSupportReportItem.prototype.setTotalAnsweredTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
 */
proto.social.voip.AdminGetSupportReportItem.prototype.clearTotalAnsweredTime = function() {
  return this.setTotalAnsweredTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.hasTotalAnsweredTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 mean_waiting_time = 5;
 * @return {number}
 */
proto.social.voip.AdminGetSupportReportItem.prototype.getMeanWaitingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.AdminGetSupportReportItem} returns this
 */
proto.social.voip.AdminGetSupportReportItem.prototype.setMeanWaitingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminGetSupportReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminGetSupportReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    query: jspb.Message.getFieldWithDefault(msg, 2, ""),
    start: jspb.Message.getFieldWithDefault(msg, 3, ""),
    end: jspb.Message.getFieldWithDefault(msg, 4, ""),
    download: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminGetSupportReportRequest}
 */
proto.social.voip.AdminGetSupportReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminGetSupportReportRequest;
  return proto.social.voip.AdminGetSupportReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminGetSupportReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminGetSupportReportRequest}
 */
proto.social.voip.AdminGetSupportReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDownload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminGetSupportReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminGetSupportReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDownload();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminGetSupportReportRequest} returns this
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminGetSupportReportRequest} returns this
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string start = 3;
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminGetSupportReportRequest} returns this
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string end = 4;
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AdminGetSupportReportRequest} returns this
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool download = 5;
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.getDownload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.voip.AdminGetSupportReportRequest} returns this
 */
proto.social.voip.AdminGetSupportReportRequest.prototype.setDownload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AccountEssentialsFields.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AccountEssentialsFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AccountEssentialsFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AccountEssentialsFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AccountEssentialsFields}
 */
proto.social.voip.AccountEssentialsFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AccountEssentialsFields;
  return proto.social.voip.AccountEssentialsFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AccountEssentialsFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AccountEssentialsFields}
 */
proto.social.voip.AccountEssentialsFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AccountEssentialsFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AccountEssentialsFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AccountEssentialsFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AccountEssentialsFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.social.voip.AccountEssentialsFields.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AccountEssentialsFields} returns this
 */
proto.social.voip.AccountEssentialsFields.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.social.voip.AccountEssentialsFields.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AccountEssentialsFields} returns this
 */
proto.social.voip.AccountEssentialsFields.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.social.voip.AccountEssentialsFields.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.AccountEssentialsFields} returns this
 */
proto.social.voip.AccountEssentialsFields.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminGetSupportReport.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminGetSupportReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminGetSupportReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.social.voip.AccountEssentialsFields.toObject(includeInstance, f),
    inTimeRange: (f = msg.getInTimeRange()) && proto.social.voip.AdminGetSupportReportItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminGetSupportReport}
 */
proto.social.voip.AdminGetSupportReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminGetSupportReport;
  return proto.social.voip.AdminGetSupportReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminGetSupportReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminGetSupportReport}
 */
proto.social.voip.AdminGetSupportReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.AccountEssentialsFields;
      reader.readMessage(value,proto.social.voip.AccountEssentialsFields.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 2:
      var value = new proto.social.voip.AdminGetSupportReportItem;
      reader.readMessage(value,proto.social.voip.AdminGetSupportReportItem.deserializeBinaryFromReader);
      msg.setInTimeRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminGetSupportReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminGetSupportReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminGetSupportReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.social.voip.AccountEssentialsFields.serializeBinaryToWriter
    );
  }
  f = message.getInTimeRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.social.voip.AdminGetSupportReportItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional AccountEssentialsFields account = 1;
 * @return {?proto.social.voip.AccountEssentialsFields}
 */
proto.social.voip.AdminGetSupportReport.prototype.getAccount = function() {
  return /** @type{?proto.social.voip.AccountEssentialsFields} */ (
    jspb.Message.getWrapperField(this, proto.social.voip.AccountEssentialsFields, 1));
};


/**
 * @param {?proto.social.voip.AccountEssentialsFields|undefined} value
 * @return {!proto.social.voip.AdminGetSupportReport} returns this
*/
proto.social.voip.AdminGetSupportReport.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminGetSupportReport} returns this
 */
proto.social.voip.AdminGetSupportReport.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReport.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AdminGetSupportReportItem in_time_range = 2;
 * @return {?proto.social.voip.AdminGetSupportReportItem}
 */
proto.social.voip.AdminGetSupportReport.prototype.getInTimeRange = function() {
  return /** @type{?proto.social.voip.AdminGetSupportReportItem} */ (
    jspb.Message.getWrapperField(this, proto.social.voip.AdminGetSupportReportItem, 2));
};


/**
 * @param {?proto.social.voip.AdminGetSupportReportItem|undefined} value
 * @return {!proto.social.voip.AdminGetSupportReport} returns this
*/
proto.social.voip.AdminGetSupportReport.prototype.setInTimeRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.AdminGetSupportReport} returns this
 */
proto.social.voip.AdminGetSupportReport.prototype.clearInTimeRange = function() {
  return this.setInTimeRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.AdminGetSupportReport.prototype.hasInTimeRange = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.AdminGetSupportReportResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.AdminGetSupportReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.AdminGetSupportReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.AdminGetSupportReport.toObject, includeInstance),
    fileContent: msg.getFileContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.AdminGetSupportReportResponse}
 */
proto.social.voip.AdminGetSupportReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.AdminGetSupportReportResponse;
  return proto.social.voip.AdminGetSupportReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.AdminGetSupportReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.AdminGetSupportReportResponse}
 */
proto.social.voip.AdminGetSupportReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.AdminGetSupportReport;
      reader.readMessage(value,proto.social.voip.AdminGetSupportReport.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.AdminGetSupportReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.AdminGetSupportReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.AdminGetSupportReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.AdminGetSupportReport.serializeBinaryToWriter
    );
  }
  f = message.getFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * repeated AdminGetSupportReport items = 1;
 * @return {!Array<!proto.social.voip.AdminGetSupportReport>}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.AdminGetSupportReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.AdminGetSupportReport, 1));
};


/**
 * @param {!Array<!proto.social.voip.AdminGetSupportReport>} value
 * @return {!proto.social.voip.AdminGetSupportReportResponse} returns this
*/
proto.social.voip.AdminGetSupportReportResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.AdminGetSupportReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.AdminGetSupportReport}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.AdminGetSupportReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.AdminGetSupportReportResponse} returns this
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional bytes file_content = 2;
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.getFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes file_content = 2;
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {string}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.getFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileContent()));
};


/**
 * optional bytes file_content = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {!Uint8Array}
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.getFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.social.voip.AdminGetSupportReportResponse} returns this
 */
proto.social.voip.AdminGetSupportReportResponse.prototype.setFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.VoipLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.VoipLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.VoipLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    query: jspb.Message.getFieldWithDefault(msg, 2, ""),
    start: jspb.Message.getFieldWithDefault(msg, 3, ""),
    end: jspb.Message.getFieldWithDefault(msg, 4, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 5, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 6, 0),
    download: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.VoipLogRequest}
 */
proto.social.voip.VoipLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.VoipLogRequest;
  return proto.social.voip.VoipLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.VoipLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.VoipLogRequest}
 */
proto.social.voip.VoipLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDownload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.VoipLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.VoipLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.VoipLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getDownload();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.social.voip.VoipLogRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.social.voip.VoipLogRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string start = 3;
 * @return {string}
 */
proto.social.voip.VoipLogRequest.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string end = 4;
 * @return {string}
 */
proto.social.voip.VoipLogRequest.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 offset = 5;
 * @return {number}
 */
proto.social.voip.VoipLogRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 limit = 6;
 * @return {number}
 */
proto.social.voip.VoipLogRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool download = 7;
 * @return {boolean}
 */
proto.social.voip.VoipLogRequest.prototype.getDownload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.voip.VoipLogRequest} returns this
 */
proto.social.voip.VoipLogRequest.prototype.setDownload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.VoipLog.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.VoipLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.VoipLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && services_account_account_pb.Account.toObject(includeInstance, f),
    operator: (f = msg.getOperator()) && services_account_account_pb.Account.toObject(includeInstance, f),
    roomId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    networkId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    operatorJoinedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    score: jspb.Message.getFieldWithDefault(msg, 7, 0),
    comment: jspb.Message.getFieldWithDefault(msg, 8, ""),
    finishedAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
    id: jspb.Message.getFieldWithDefault(msg, 10, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
    roomName: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.VoipLog}
 */
proto.social.voip.VoipLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.VoipLog;
  return proto.social.voip.VoipLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.VoipLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.VoipLog}
 */
proto.social.voip.VoipLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new services_account_account_pb.Account;
      reader.readMessage(value,services_account_account_pb.Account.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 2:
      var value = new services_account_account_pb.Account;
      reader.readMessage(value,services_account_account_pb.Account.deserializeBinaryFromReader);
      msg.setOperator(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 4:
      var value = /** @type {!proto.social.voip.QueueConnectionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatorJoinedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFinishedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.VoipLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.VoipLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.VoipLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      services_account_account_pb.Account.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      services_account_account_pb.Account.serializeBinaryToWriter
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOperatorJoinedAt();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFinishedAt();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getRoomName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional social.account.Account client = 1;
 * @return {?proto.social.account.Account}
 */
proto.social.voip.VoipLog.prototype.getClient = function() {
  return /** @type{?proto.social.account.Account} */ (
    jspb.Message.getWrapperField(this, services_account_account_pb.Account, 1));
};


/**
 * @param {?proto.social.account.Account|undefined} value
 * @return {!proto.social.voip.VoipLog} returns this
*/
proto.social.voip.VoipLog.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.VoipLog.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional social.account.Account operator = 2;
 * @return {?proto.social.account.Account}
 */
proto.social.voip.VoipLog.prototype.getOperator = function() {
  return /** @type{?proto.social.account.Account} */ (
    jspb.Message.getWrapperField(this, services_account_account_pb.Account, 2));
};


/**
 * @param {?proto.social.account.Account|undefined} value
 * @return {!proto.social.voip.VoipLog} returns this
*/
proto.social.voip.VoipLog.prototype.setOperator = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.clearOperator = function() {
  return this.setOperator(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.voip.VoipLog.prototype.hasOperator = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string room_id = 3;
 * @return {string}
 */
proto.social.voip.VoipLog.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional QueueConnectionType type = 4;
 * @return {!proto.social.voip.QueueConnectionType}
 */
proto.social.voip.VoipLog.prototype.getType = function() {
  return /** @type {!proto.social.voip.QueueConnectionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.social.voip.QueueConnectionType} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string network_id = 5;
 * @return {string}
 */
proto.social.voip.VoipLog.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 operator_joined_at = 6;
 * @return {number}
 */
proto.social.voip.VoipLog.prototype.getOperatorJoinedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setOperatorJoinedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 score = 7;
 * @return {number}
 */
proto.social.voip.VoipLog.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string comment = 8;
 * @return {string}
 */
proto.social.voip.VoipLog.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 finished_at = 9;
 * @return {number}
 */
proto.social.voip.VoipLog.prototype.getFinishedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setFinishedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string id = 10;
 * @return {string}
 */
proto.social.voip.VoipLog.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 created_at = 11;
 * @return {number}
 */
proto.social.voip.VoipLog.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string room_name = 12;
 * @return {string}
 */
proto.social.voip.VoipLog.prototype.getRoomName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipLog} returns this
 */
proto.social.voip.VoipLog.prototype.setRoomName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.VoipLogResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.VoipLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.VoipLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.VoipLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.VoipLog.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    fileContent: msg.getFileContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.VoipLogResponse}
 */
proto.social.voip.VoipLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.VoipLogResponse;
  return proto.social.voip.VoipLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.VoipLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.VoipLogResponse}
 */
proto.social.voip.VoipLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.VoipLog;
      reader.readMessage(value,proto.social.voip.VoipLog.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.VoipLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.VoipLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.VoipLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.VoipLog.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * repeated VoipLog items = 1;
 * @return {!Array<!proto.social.voip.VoipLog>}
 */
proto.social.voip.VoipLogResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.VoipLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.VoipLog, 1));
};


/**
 * @param {!Array<!proto.social.voip.VoipLog>} value
 * @return {!proto.social.voip.VoipLogResponse} returns this
*/
proto.social.voip.VoipLogResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.VoipLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.VoipLog}
 */
proto.social.voip.VoipLogResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.VoipLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.VoipLogResponse} returns this
 */
proto.social.voip.VoipLogResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.voip.VoipLogResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.VoipLogResponse} returns this
 */
proto.social.voip.VoipLogResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes file_content = 3;
 * @return {string}
 */
proto.social.voip.VoipLogResponse.prototype.getFileContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes file_content = 3;
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {string}
 */
proto.social.voip.VoipLogResponse.prototype.getFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileContent()));
};


/**
 * optional bytes file_content = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {!Uint8Array}
 */
proto.social.voip.VoipLogResponse.prototype.getFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.social.voip.VoipLogResponse} returns this
 */
proto.social.voip.VoipLogResponse.prototype.setFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.QuickAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.QuickAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.QuickAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    answer: jspb.Message.getFieldWithDefault(msg, 3, ""),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.QuickAnswer}
 */
proto.social.voip.QuickAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.QuickAnswer;
  return proto.social.voip.QuickAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.QuickAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.QuickAnswer}
 */
proto.social.voip.QuickAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswer(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.QuickAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.QuickAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.QuickAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnswer();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.social.voip.QuickAnswer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAnswer} returns this
 */
proto.social.voip.QuickAnswer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.social.voip.QuickAnswer.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAnswer} returns this
 */
proto.social.voip.QuickAnswer.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string answer = 3;
 * @return {string}
 */
proto.social.voip.QuickAnswer.prototype.getAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAnswer} returns this
 */
proto.social.voip.QuickAnswer.prototype.setAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.social.voip.QuickAnswer.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAnswer} returns this
 */
proto.social.voip.QuickAnswer.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string operator = 5;
 * @return {string}
 */
proto.social.voip.QuickAnswer.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.QuickAnswer} returns this
 */
proto.social.voip.QuickAnswer.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.voip.QuickAnswerListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.QuickAnswerListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.QuickAnswerListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.QuickAnswerListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAnswerListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.voip.QuickAnswer.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.QuickAnswerListResponse}
 */
proto.social.voip.QuickAnswerListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.QuickAnswerListResponse;
  return proto.social.voip.QuickAnswerListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.QuickAnswerListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.QuickAnswerListResponse}
 */
proto.social.voip.QuickAnswerListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.voip.QuickAnswer;
      reader.readMessage(value,proto.social.voip.QuickAnswer.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.QuickAnswerListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.QuickAnswerListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.QuickAnswerListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.QuickAnswerListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.voip.QuickAnswer.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated QuickAnswer items = 1;
 * @return {!Array<!proto.social.voip.QuickAnswer>}
 */
proto.social.voip.QuickAnswerListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.voip.QuickAnswer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.voip.QuickAnswer, 1));
};


/**
 * @param {!Array<!proto.social.voip.QuickAnswer>} value
 * @return {!proto.social.voip.QuickAnswerListResponse} returns this
*/
proto.social.voip.QuickAnswerListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.voip.QuickAnswer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.voip.QuickAnswer}
 */
proto.social.voip.QuickAnswerListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.voip.QuickAnswer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.voip.QuickAnswerListResponse} returns this
 */
proto.social.voip.QuickAnswerListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.voip.QuickAnswerListResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.voip.QuickAnswerListResponse} returns this
 */
proto.social.voip.QuickAnswerListResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.voip.VoipCallRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.voip.VoipCallRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.voip.VoipCallRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipCallRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.voip.VoipCallRequest}
 */
proto.social.voip.VoipCallRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.voip.VoipCallRequest;
  return proto.social.voip.VoipCallRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.voip.VoipCallRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.voip.VoipCallRequest}
 */
proto.social.voip.VoipCallRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.voip.VoipCallRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.voip.VoipCallRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.voip.VoipCallRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.voip.VoipCallRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string room_name = 1;
 * @return {string}
 */
proto.social.voip.VoipCallRequest.prototype.getRoomName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipCallRequest} returns this
 */
proto.social.voip.VoipCallRequest.prototype.setRoomName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string phone = 4;
 * @return {string}
 */
proto.social.voip.VoipCallRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipCallRequest} returns this
 */
proto.social.voip.VoipCallRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string username = 5;
 * @return {string}
 */
proto.social.voip.VoipCallRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.voip.VoipCallRequest} returns this
 */
proto.social.voip.VoipCallRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.social.voip.SupportStatus = {
  OFFLINE: 0,
  TALKING: 1,
  ONLINE: 2
};

/**
 * @enum {number}
 */
proto.social.voip.QueueConnectionType = {
  MEETING: 0,
  CHAT: 1
};

goog.object.extend(exports, proto.social.voip);
